import React, { useState, useEffect, useRef } from 'react';
import intl from 'react-intl-universal';
import { Link, useLocation } from 'react-router-dom';
import { AppConsumer } from '../../context/AppContext';
import { isMobile, setLocale } from '../../utils/helpers';
import logoBlack from '../../assets/logo@2x.png';
import logoWhite from '../../assets/logo-white@2x.png';

import './index.scss';

const PCHeader = ({ isCN, path }) => {
  const [isScroll, setIsScroll] = useState(false);

  // TODO: 节流
  const onScroll = () => {
    const scrollTop = window.pageYOffset;
    if (scrollTop > 0) {
      setIsScroll(true);
    } else {
      setIsScroll(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <header className={isScroll ? 'scroll-header' : ''}>
      <div className="header">
        <div className="logo">
          {isScroll ? (
            <img src={logoBlack} alt="kuaishou" />
          ) : (
              <img src={logoWhite} alt="kuaishou" />
            )}
          {/* <span>{intl.get('header.title')}</span> */}
        </div>
        <div className="menu">
          <ul>
            <li className={path === '/' ? 'choose' : ''}>
              <Link to="/">{intl.get('header.home')}</Link>
            </li>
            <li className={path === '/labs' ? 'choose' : ''}>
              <Link to="labs">{intl.get('header.labs')}</Link>
            </li>
            <li className={path === '/join-us' ? 'choose' : ''}>
              <Link to="/join-us">{intl.get('header.join')}</Link>
            </li>
            <li>
              <span
                className={isCN ? 'active' : ''}
                onClick={() => setLocale('zh-CN')}
              >
                简
              </span>
              /
              <span
                className={isCN ? '' : 'active'}
                onClick={() => setLocale('en-US')}
              >
                EN
              </span>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

const MobileHeader = ({ isCN, path }) => {
  const [isShowMenu, setMenuVisible] = useState(false);

  const showMenu = () => {
    if (isShowMenu) return;
    setMenuVisible(true);
  };

  const hiddenMenu = () => {
    setMenuVisible(false);
  };

  const handleClickMenu = (e) => {
    if (
      e.target.tagName === 'A' ||
      e.target.tagName === 'LI' ||
      e.target.tagName === 'IMG' ||
      e.target.tagName === 'SPAN'
    ) {
      hiddenMenu();
    }
  };

  return (
    <header className="mobile">
      <div className="mobile-header">
        <div className="logo">
          <img src={logoBlack} alt="" />
          {/* <span>{intl.get('header.title')}</span> */}
        </div>
        <div className="menu" onClick={showMenu}>
          {isShowMenu && (
            <div className="menu-detail">
              <div className="menu-wrapper">
                <div className="menu-title">
                  <div className="hidden" onClick={hiddenMenu} />
                </div>
                <div className="menu-content" onClick={handleClickMenu}>
                  <div className="list">
                    <ul>
                      <li className={path === '/' ? 'choose' : ''}>
                        <Link to="/">{intl.get('header.home')}</Link>
                      </li>
                      <li className={path === '/labs' ? 'choose' : ''}>
                        <Link to="labs">{intl.get('header.labs')}</Link>
                      </li>
                      <li className={path === '/join-us' ? 'choose' : ''}>
                        <Link to="/join-us">{intl.get('header.join')}</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="lang">
                    <span
                      className={isCN ? 'active' : ''}
                      onClick={() => setLocale('zh-CN')}
                    >
                      简体
                    </span>
                    /
                    <span
                      className={isCN ? '' : 'active'}
                      onClick={() => setLocale('en-US')}
                    >
                      ENGLISH
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

const Header = ({ contextData }) => {
  const { currentLocale } = contextData;
  const isCN = currentLocale === 'zh-CN';
  const location = useLocation();
  const { pathname: path } = location;

  return isMobile() ? (
    <MobileHeader isCN={isCN} path={path} />
  ) : (
      <PCHeader isCN={isCN} path={path} />
    );
};

export default AppConsumer(Header);
